<template>
    <div v-if="agreementDocument">
        <privacy-document-view
            :document="agreementDocument"
            :no-body="true"
        >
            <template #title v-if="versionSelected && versionSelected.version">
                <span>{{$t("org.auth.agreementToCollectAndUsePersonalInformation")}} ({{ versionSelected.version }})</span>
            </template>
            <template #agreement>
                <b-badge v-if="userInfo && userInfo.singedTcDt" class="d-block p-2 mb-1 font-small-4" variant="success">
                    {{ $t("org.auth.agreedToPersonalInformationUse") }} [{{ userInfo.singedTcDt }}]
                </b-badge>
                <b-badge v-else class="d-block p-2 mb-1 font-small-4" variant="danger">
                    <p class="mb-0">{{$t("org.auth.youCanKeepUsingIfYouAgree")}}</p>
                </b-badge>
            </template>
            <template
                #button
                v-if="userInfo && !userInfo.singedTcDt"
            >
                <b-button variant="primary" @click="signAgreement()" block>
                    <feather-icon icon="CheckSquareIcon" />
                    <span class="ml-1">{{ $t('org.auth.iAgreeToTermsOfServiceAbove') }}</span>
                </b-button>
            </template>
        </privacy-document-view>
    </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getCurrentInstance, ref, computed, watch } from '@vue/composition-api'
import PrivacyDocumentView from './components/PrivacyDocumentView'

export default {
    components: {
        PrivacyDocumentView
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        /* data */
        const versions = ref([])
        const versionSelected = ref({
            label: '',
            value: '',
            version: null
        })

        /* computed */
        const locale = computed(() => vm.$i18n.locale)
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const userInfo = computed(() => store.getters.userInfo)
        const agreementDocument = computed(() => store.getters.agreementDocument)

        /* methods */
        const signAgreement = () => {
            store.dispatch('signAgreement', { userIdx: authUserInfo.value.userIdx, signedTc: true }).then(() => {
                store.dispatch('createMemberAuthAgain', { email: userInfo.value.email }).then((result) => {
                    store.dispatch('getProfileUserInfo', { userIdx: userInfo.value.userIdx }).then(() => {
                        vm.$toast({
                            component: ToastificationContent,
                            props: {
                                title: vm.$t('org.auth.agreeToTermsOfService'),
                                icon: 'CheckCircleIcon',
                                variant: 'success'
                            }
                        })
                        window.scrollTo({ top: 0, behavior: 'smooth' })

                        if (result.prerequisites.length > 0) {
                            if (result.prerequisites[0] === 'otp' || result.prerequisites[0] === 'password') {
                                vm.$bvModal.msgBoxConfirm(vm.$t('org.message.Would you like to go to that page'), {
                                    title: vm.$t('org.message.Prerequisites are required'),
                                    cancelVariant: 'outline-secondary'
                                }).then(value => {
                                    if (value) vm.$router.push({ name: `${result.prerequisites[0]}` })
                                })
                            }
                        }
                    })
                })
            })
        }

        const getVersions = () => {
            store.dispatch('getAgreementDocumentVersions', { locale: locale.value }).then((data) => {
                versions.value = data.data.map(content => {
                    return {
                        label: content.replace('.json', ''),
                        value: content.replace('.json', ''),
                        version: content.replace('.json', '')
                    }
                }).sort((a, b) => a.value > b.value ? -1 : 1)
                versionSelected.value = versions.value[0]
            })
        }

        /* watch */
        watch(versionSelected, (value) => {
            if (value) {
                store.dispatch('getAgreementDocumentContent', { locale: locale.value, version: value.value })
            }
        })

        watch(() => locale.value, () => {
            getVersions()
        })

        getVersions()

        return {
            versionSelected,
            authUserInfo,
            userInfo,
            agreementDocument,
            signAgreement
        }
    }
}
</script>

<style>
.dark-layout .collapse-style .table-bordered.table-sm tbody tr th {
    color:#000
}
</style>
